<template>
  <div class="relative">
    <svg :class="svgClass" aria-hidden="true" v-on="$listeners">
      <use :xlink:href="iconName" />
    </svg>
    <svg v-if="dot" class="svg-icon dot text-xl" aria-hidden="true">
      <use xlink:href="#icon-dot" />
    </svg>
  </div>
</template>

<script>

export default {
  name: 'SvgIcon',
  props: {
    iconClass: {
      type: String,
      required: true,
    },
    className: {
      type: String,
      default: '',
    },
    dot: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    iconName() {
      return `#icon-${this.iconClass}`;
    },
    svgClass() {
      if (this.className) {
        return `svg-icon ${this.className}`;
      }
      return 'svg-icon';
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/styles/variables';

.svg-icon {
  fill: $colorIcon;
  height: 1em;
  overflow: hidden;
  vertical-align: -0.15em;
  width: 1em;
}

.svg-external-icon {
  background-color: currentColor;
  display: inline-block;

  mask-size: cover !important;
}

.dot {
  position: absolute;
  right: 0;
  top: 0;
  transform: scale(0.5);
}
</style>
